import { createSlice } from "@reduxjs/toolkit";
import { GetWheelStateThunk } from "./luckyWheel.thunk";
import { WheelState } from "./luckyWheel.api";

export const InitialLuckyWheelState = {
  festivalState: undefined as WheelState | undefined,
};

const LuckyWheelSlice = createSlice({
  name: "LuckyWheelSlice",
  initialState: InitialLuckyWheelState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetWheelStateThunk.fulfilled, (state, action) => {
        state.festivalState = action.payload ?? WheelState.INACTIVE;
      })
      .addCase(GetWheelStateThunk.rejected, (state, action) => {
        state.festivalState = WheelState.INACTIVE;
      });
  },
});

export const LuckyWheelActions = {
  ...LuckyWheelSlice.actions,
};
export const LuckyWheelReducer = LuckyWheelSlice.reducer;
